module.exports = __webpack_public_path__ + "img/collection-weddingRingsPlain@2x.d6af60b.jpg";